import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconKey = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.2305 1.7704C11.8631 -0.590134 8.02404 -0.590134 5.67262 1.7704C4.01704 3.41077 3.52117 5.77131 4.16101 7.85178L0.401968 11.6126C0.138035 11.8847 -0.0459181 12.4208 0.0100676 12.8049L0.250006 14.5493C0.337984 15.1254 0.873847 15.6696 1.4497 15.7496L3.19325 15.9896C3.57716 16.0456 4.11302 15.8696 4.38495 15.5895L5.04078 14.9334C5.20074 14.7813 5.20074 14.5253 5.04078 14.3653L3.48918 12.8129C3.25724 12.5808 3.25724 12.1968 3.48918 11.9647C3.72112 11.7327 4.10502 11.7327 4.33696 11.9647L5.89656 13.5251C6.04853 13.6771 6.30446 13.6771 6.45644 13.5251L8.152 11.8367C10.2235 12.4848 12.5829 11.9807 14.2305 10.3403C16.5898 7.9798 16.5898 4.13094 14.2305 1.7704ZM9.99953 7.99581C8.89581 7.99581 8.00004 7.09961 8.00004 5.99536C8.00004 4.89111 8.89581 3.99491 9.99953 3.99491C11.1032 3.99491 11.999 4.89111 11.999 5.99536C11.999 7.09961 11.1032 7.99581 9.99953 7.99581Z",
		fill: "currentColor"
	})
});
export default SvgIconKey;
